import Highcharts from 'highcharts';

Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});

export const figure69 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        height: '600px',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
      exporting: {
        enabled: false
      },
      legend: {
        enabled: false,
      },
      xAxis: [{
        categories: [ 2000, 2005, 2010, 2015, 2016, 2017, 2018, 2019, 2020, 2021 ],
        tickInterval: 1,
        crosshair: {
            width: 1,
            color: '#d7d7d7'
        },
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
            y: 32,
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            }
        },
    }],

    yAxis: [
        {
        labels: {
            format: '{value}',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
        offset: 10,
        gridLineWidth: 2,
        max: 500,
        min: 0,
        tickInterval: 50,
        title: {
            text: "Milliers",
            offset: 50,
            style: {
                fontSize:'18px',
                color: Highcharts.getOptions().colors[1]
            }
        }
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
            padding: 0
        }
    },
    plotOptions: {
        series: {
            states: {
                hover: {
                    lineWidth: 2
                }
            },
            marker: {
                symbol: 'circle',
                states: {
                    hover: {
                        enabled: true,
                        radius: 5
                    }
                }
            }
        }
    },
    series: [ 
        {
        name: 'Monde',
        type: 'line',
            color: '#ed7d30',
        zoneAxis: 'x',
        data: [51.3, 239.4, 343.4, 397.5, 423.8, 431.7, 422.7, 426.3, 435.5, 462.9,
        ],
	},
	{
		marker: {
				enabled: false
			},
			name: 'Europe et Amérique du Nord',
			type: 'line',
			color: '#43682b',
			zoneAxis: 'x',
			data: [ 48.2, 221.0, 302.1, 344.0, 352.1, 359.7, 364.7, 366.1, 367.6, 389.5,
			      ],
	},
	     
    {
        name: 'Asie centrale et du Sud',
        type: 'line',
        color: '#7baedd',
        zoneAxis: 'x',
        data: [1.8,  
	      3.2, 
	      3.8, 
	      8.3,
	      7.7,
	      5.2,
	      5.3,
	      6.5,
	      5.6,
	      5.6

        ],
    },
    {
        marker: {
            enabled: false
        },
        name: 'Asie de l’Est et du Sud-Est',
        type: 'line',
        color: '#a4a4a5',
        zoneAxis: 'x',
        data: [2.7, 8.7, 8.43, 17.4,18.4, 20.4,22.2,21.2,  18.9, 18.6
        ],
    },
    {
        marker: {
            enabled: false
        },
        name: 'Afrique du Nord et Asie de l’Ouest',
        type: 'line',
        color: '#71ad47',
        zoneAxis: 'x',
        data: [  0, 0, 2.0, 2.3, 2.3, 2.3, 2.3, 3.1, 6.4, 6.6
        ],
    },

    {
        marker: {
            enabled: false
        },
        name: 'Afrique subsaharienne',
        type: 'line',
        color: '#636363',
        zoneAxis: 'x',
        data: [ 1.1, 2.3, 7.3, 6.3,7.6,7.6,7.0,6.7,  9.0, 9.3
         ],
    },
    {
        marker: {
            enabled: false
        },
        name: 'Amérique latine et Caraïbes',
        type: 'line',
        color: '#ffcd32',
        zoneAxis: 'x',
        data: [ 1.5, 8.4, 13.8, 14.5,14.3,15.5,15.4,15.4,  19.928,20.1
        ],
        },
        {
            marker: {
                enabled: false
            },
            name: 'Océanie',
            type: 'line',
            color: '#6b8ed0',
            zoneAxis: 'x',
            data: [ 2.5,6.64, 11.584, 12.033, 28.200, 25.677, 10.345, 12.984, 12.870, 17.905
            ],
        },

  ],

}